import React from "react";
import { Grid, GridProps } from "@mui/material";

type ResponsiveFormContainerProps = {
  children: React.ReactNode;
  columns?: number;
  subtitle?: string;
} & GridProps;

const ResponsiveFormContainer = ({
  children,
  columns,
  subtitle,
  ...props
}: ResponsiveFormContainerProps) => {
  return (
    <Grid container spacing={2} {...props}>
      {React.Children.map(children, (child, index) =>
        child ? (
          <Grid
            key={`child-${index}`}
            item
            xs={12}
            sm={columns ? 12 / columns : 6}
            md={columns ? 12 / columns : 4}
          >
            {child}
          </Grid>
        ) : null
      )}
    </Grid>
  );
};

export default ResponsiveFormContainer;
